import { render, staticRenderFns } from "./FormNumberInput.vue?vue&type=template&id=ed07d028&scoped=true"
import script from "./FormNumberInput.vue?vue&type=script&lang=ts"
export * from "./FormNumberInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed07d028",
  null
  
)

export default component.exports